import React from 'react';
import ArmChairBottom from "./ArmChairBottom"

export default function SideChairBottom(props) {
    return ArmChairBottom(props)
}